import React, { Component } from "react";
import CustomIcons from "../../../components/icons/kIcons.component";
import {
  tender_cate_data,
  tender_orgn_data,
  user_tenders_list,
} from "../user.api";
import "./tenders.css";
import Moment from "react-moment";
import moment from "moment";
import ReactHtmlParser from "react-html-parser";
import SearchButton from "../../../components/buttons/search/search-btn";
import BreadCrumbsComp from "../../../components/navigator/breadcrumbs";
import BreadCrumpBack from "../../../components/navigator/back";

class PrivateTenders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      url: "",
      currentPage: 1,
      itemsPerPage: 5,
    };
  }

  componentDidMount = () => {
    this.fetchTender();
    this.fetchOrganisation();
    this.fetchCategory();
  };

  fetchTender = (orgId = "", catId = "") => {
    user_tenders_list().then((res) => {
      const currentDate = moment();

      const filteredData = res?.data?.filter((item) => {
        const isPrivate = item?.type === "private";
        const isPublished = item?.tender_publish_status === 1;
        const isFuture = moment(item?.due_date, "YYYY-MM-DD").isAfter(
          currentDate
        );
        const matchesOrg = orgId ? item?.organisation?.id == orgId : true;
        const matchesCat = catId ? item?.category?.id == catId : true;

        return isPrivate && isPublished && isFuture && matchesOrg && matchesCat;
      });

      this.setState({
        data: filteredData,
        url: res?.current_url,
        currentPage: 1,
      });
    });
  };

  handleLink = (linkurl) => {
    let urlLower = linkurl.toLowerCase();
    let urlStart = urlLower.substring(0, 4);
    if (urlStart === "http") {
      window.open(`${urlLower}`, "_blank");
    } else {
      window.open(`//${urlLower}`, "_blank");
    }
  };
  handleDownloadProof = (file) => {
    const servInstance = process.env.REACT_APP_BASE_URL;
    let result = servInstance.substring(0, servInstance?.length - 4);
    let path = `${result}${file}`;
    window.open(path, "_blank");
  };

  handleOrganisationChange = (e) => {
    const selectedOrgId = e.target.value;
    this.setState({ selectedOrgId, currentPage: 1 }, () => { });
  };
  handleCategoryChange = (e) => {
    const selectedCatId = e.target.value;
    this.setState({ selectedCatId, currentPage: 1 }, () => { });
  };
  fetchOrganisation = () => {
    return tender_orgn_data()
      .then((res) => {
        const filtered = res?.filter(
          (item) => item?.name?.toLowerCase().trim() !== "others"
        );
        this.setState({ orgdata: filtered });
      })
      .catch((err) => {
        console.error("Error fetching organisation:", err);
      });
  };

  fetchCategory = () => {
    return tender_cate_data()
      .then((res) => {
        const filtered = res?.filter(
          (item) => item?.name?.toLowerCase().trim() !== "others"
        );
        this.setState({ catdata: filtered });
      })
      .catch((err) => {
        console.error("Error fetching category:", err);
      });
  };

  handleSearch = async () => {
    try {
      const { selectedOrgId, selectedCatId } = this.state;
      this.setState({ currentPage: 1 }, () => {
        this.fetchTender(selectedOrgId, selectedCatId);
      });
    } catch (err) {
      console.error("Error during search process:", err);
    }
  };

  formatAmount(amount) {
    return new Intl.NumberFormat("en-IN").format(amount);
  }
  render() {
    const { data, url, currentPage, itemsPerPage } = this.state;
    const { orgdata, selectedOrgId } = this.state;
    const { catdata, selectedCatId } = this.state;

    const currentDate = moment();

    // Pagination calculations
    const totalItems = data.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

    return (
      <div className="tender bg-tender">
        <div>
          <div className="dash-banner ">
            <div className="tix">
              {this.props.state.language === "ma"
                ? "വാണിജ്യ അന്വേഷണങ്ങൾ"
                : "Trade Enquiries"}
            </div>
          </div>
        </div>
        <BreadCrumpBack />


        <div className="container p-50">
          <div className="d-flex   org-tender row my-4">
            <div className="col-4">
              <div className=" col-xs-12 col-sm-12 col-md-10">
                <div className="header-label mb-1">Organisation</div>
                <select
                  className="form-select selectbox mandatory-select "
                  required
                  name="organisation"
                  aria-label="Default select example"
                  value={selectedOrgId}
                  onChange={this.handleOrganisationChange}
                >
                  <option value="">-- Select--</option>
                  {orgdata?.map((item) => (
                    <option value={item.id} key={item.id}>
                      {item?.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-4">
              <div className=" col-xs-12 col-sm-12 col-md-10">
                <div className="header-label mb-1">Category</div>
                <select
                  className="form-select selectbox mandatory-select "
                  required
                  name="category"
                  aria-label="Default select example"
                  value={selectedCatId}
                  onChange={this.handleCategoryChange}
                >
                  <option value="">-- Select--</option>
                  {catdata?.map((item) => (
                    <option value={item?.id} key={item?.id}>
                      {item?.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-2 d-flex mt-4">
              <SearchButton onClick={this.handleSearch} />
            </div>
          </div>
          <div className="bg-white">
            <div className="row tender-box" >
              {currentItems?.length !== 0 ? (
                <>
                  {currentItems.map((item) => (
                    <React.Fragment>
                      {item?.tender_publish_status === 1 &&
                        item.type === "private" &&
                        moment(item?.due_date, "YYYY-MM-DD HH:mm").isAfter(
                          currentDate
                        ) && (
                          <div className="bg-tender p-30">
                            <div className="tender-title mb-2">
                              <p
                                className="head "
                                style={{ overflowWrap: "break-word" }}
                              >
                                <u>
                                  {this.props.state.language === "ma"
                                    ? item?.title_ma
                                    : item?.tender_title}
                                </u>
                              </p>
                            </div>
                            {/* <div className="tender-datas">
                              <div className="col-lg-2 col-md-12 col-sm-12 label">
                                <p>Tender By</p>
                              </div>
                              <div className="col-lg-10 col-md-12 col-sm-12 contentx">
                                <p>
                                  {this.props.state.language === "ma"
                                    ? item?.organized_by_ma
                                    : item?.organized_by}
                                </p>
                              </div>
                            </div> */}
                            {item?.ref_no && (
                              <div className="tender-datas">
                                <div className="col-lg-2 col-md-12 col-sm-12 label">
                                  <p>Reference Number</p>
                                </div>
                                <div className="col-lg-10 col-md-12 col-sm-12 contentx note">
                                  <p>
                                    {item?.ref_no
                                      ? item?.ref_no
                                      : ""}
                                  </p>
                                </div>
                              </div>
                            )}
                            {item?.organisation && (
                              <div className="tender-datas">
                                <div className="col-lg-2 col-md-12 col-sm-12 label">
                                  <p>Organisation</p>
                                </div>
                                <div className="col-lg-10 col-md-12 col-sm-12 contentx note">
                                  <p>
                                    {item?.organisation.name
                                      ? ReactHtmlParser(item?.organisation.name)
                                      : ""}
                                  </p>
                                </div>
                              </div>
                            )}
                            {item?.category && (
                              <div className="tender-datas">
                                <div className="col-lg-2 col-md-12 col-sm-12 label">
                                  <p>Category</p>
                                </div>
                                <div className="col-lg-10 col-md-12 col-sm-12 contentx note">
                                  <p>
                                    {item?.category.name
                                      ? ReactHtmlParser(item?.category.name)
                                      : ""}
                                  </p>
                                </div>
                              </div>
                            )}

                            <div className="tender-datas">
                              <div className="col-lg-2 col-md-12 col-sm-12 label">
                                <p>Description</p>
                              </div>
                              <div className="col-lg-10 col-md-12 col-sm-12 contentx note">
                                <p>
                                  {this.props.state.language === "ma"
                                    ? item?.description_ma &&
                                    ReactHtmlParser(item?.description_ma)
                                    : item?.description &&
                                    ReactHtmlParser(item?.description)}
                                </p>
                              </div>
                            </div>
                            <div className="tender-datas">
                              <div className="col-lg-2 col-md-12 col-sm-12 label">
                                <p>Due Date</p>
                              </div>
                              <div className="col-lg-10 col-md-12 col-sm-12 contentx note">
                                <p>
                                  {item?.due_date
                                    ? moment(
                                      item?.due_date,
                                      "YYYY-MM-DD HH:mm"
                                    ).format("DD-MM-YYYY HH:mm")
                                    : "--"}
                                </p>
                              </div>
                            </div>
                            {item?.value_of_tender &&
                              item?.value_of_tender != 0 && (
                                <div className="tender-datas">
                                  <div className="col-lg-2 col-md-12 col-sm-12 label">
                                    <p>Value of Tender</p>
                                  </div>
                                  <div className="col-lg-10 col-md-12 col-sm-12 contentx">
                                    <p>
                                      ₹{" "}
                                      {this.formatAmount(item?.value_of_tender)}
                                    </p>
                                  </div>
                                </div>
                              )}
                            {item?.link && (
                              <div className="tender-datas">
                                <div className="col-lg-2 col-md-12 col-sm-12 label">
                                  <p>Link</p>
                                </div>
                                <div className="d-flex col-lg-10 col-md-12 col-sm-12 contentx overf">
                                  <p className="blink_me">
                                    <CustomIcons iconName={"hand"} />
                                  </p>
                                  <span>
                                    &nbsp;
                                    <a
                                      onClick={(e) =>
                                        window.open(item?.link, "_blank")
                                      }
                                      className="break_link"
                                    >
                                      {" "}
                                      {item?.link}
                                    </a>
                                  </span>
                                </div>
                              </div>
                            )}
                            {item?.file && item?.file !== "storage/" && (
                              <div className="tender-datas">
                                <div className="col-lg-2 col-md-12 col-sm-12 label">
                                  <p>Document</p>
                                </div>
                                <div className="d-flex col-lg-10 col-md-12 col-sm-12 contentx overf">
                                  <p className="blink_me">
                                    <CustomIcons iconName={"hand"} />
                                  </p>
                                  <span>
                                    &nbsp;
                                    <a
                                      onClick={(e) =>
                                        // window.open(`https://kspace.inovace.in/${item.file}`, "_blank")
                                        this.handleDownloadProof(item?.file)
                                      }
                                      className="break_link"
                                    >
                                      {" "}
                                      Download
                                    </a>
                                  </span>
                                </div>
                              </div>
                            )}

                          </div>
                        )}
                    </React.Fragment>
                  ))}

                  {totalPages > 1 && (
                    <div className="d-flex justify-content-between align-items-center mt-4 px-4 w-100 flex-wrap pagination-container" style={{ gap: '15px' }}>
                      <div className="text-muted" style={{ fontSize: "14px" }}>
                        Showing <b>{indexOfFirstItem + 1}</b> - <b>{Math.min(indexOfLastItem, totalItems)}</b> of <b>{totalItems}</b> Trade Enquiries
                      </div>
                      <div className="d-flex gap-2 align-items-center">
                        <button
                          className="btn btn-outline-primary btn-sm px-3 py-2"
                          disabled={currentPage === 1}
                          onClick={() => this.setState({ currentPage: currentPage - 1 })}
                          style={{ borderRadius: "6px", fontWeight: "600", fontSize: "13px" }}
                        >
                          <i className="fa fa-chevron-left mr-1"></i> Prev
                        </button>

                        {(() => {
                          const pages = [];
                          const maxVisible = 5;
                          let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
                          let end = Math.min(totalPages, start + maxVisible - 1);
                          if (end - start + 1 < maxVisible) {
                            start = Math.max(1, end - maxVisible + 1);
                          }

                          if (start > 1) {
                            pages.push(
                              <button
                                key={1}
                                className={`btn btn-sm px-3 py-2 ${currentPage === 1 ? "btn-primary text-white" : "btn-outline-primary"}`}
                                onClick={() => this.setState({ currentPage: 1 })}
                                style={{ borderRadius: "6px", fontWeight: "600", fontSize: "13px" }}
                              >
                                1
                              </button>
                            );
                            if (start > 2) {
                              pages.push(<span key="dots-start" className="px-2 align-self-center text-muted">...</span>);
                            }
                          }

                          for (let i = start; i <= end; i++) {
                            pages.push(
                              <button
                                key={i}
                                className={`btn btn-sm px-3 py-2 ${currentPage === i ? "btn-primary text-white" : "btn-outline-primary"}`}
                                onClick={() => this.setState({ currentPage: i })}
                                style={{ borderRadius: "6px", fontWeight: "600", fontSize: "13px" }}
                              >
                                {i}
                              </button>
                            );
                          }

                          if (end < totalPages) {
                            if (end < totalPages - 1) {
                              pages.push(<span key="dots-end" className="px-2 align-self-center text-muted">...</span>);
                            }
                            pages.push(
                              <button
                                key={totalPages}
                                className={`btn btn-sm px-3 py-2 ${currentPage === totalPages ? "btn-primary text-white" : "btn-outline-primary"}`}
                                onClick={() => this.setState({ currentPage: totalPages })}
                                style={{ borderRadius: "6px", fontWeight: "600", fontSize: "13px" }}
                              >
                                {totalPages}
                              </button>
                            );
                          }
                          return pages;
                        })()}

                        <button
                          className="btn btn-outline-primary btn-sm px-3 py-2"
                          disabled={currentPage === totalPages}
                          onClick={() => this.setState({ currentPage: currentPage + 1 })}
                          style={{ borderRadius: "6px", fontWeight: "600", fontSize: "13px" }}
                        >
                          Next <i className="fa fa-chevron-right ml-1"></i>
                        </button>
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <>
                  <div className="no-data">
                    <img src="resources/img/no1.png" alt="" />
                    <h4>No Records Found..!!</h4>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default PrivateTenders;
